import React, { useState, useEffect } from "react";
import DetailsCard from "./components/DetailsCard";
import LineChart from "./components/Chart";
import { useUser } from "../../context/UserContext";
import httpServices from "../../services/httpServices";
import { NavLink, useNavigate } from "react-router-dom";
import DateSelect from "../../component/common/DatePicker";
import formatDate from "../../utils/dateFormater"; // remove this
import { format } from "date-fns";
import COLUMNS from "./_constants/EventsColumns";
import EventTable from "./_constants/EventTable";

function Home() {
  const { user } = useUser();

  const navigate = useNavigate();
  const { startDate: defaultStartDate, endDate: defaultEndDate } =
    calculateDateRange("24H");

  const [startDate, setStartDate] = useState(defaultStartDate);
  const [endDate, setEndDate] = useState(defaultEndDate);

  const [selectedRange, setSelectedRange] = useState("24H");
  const [dashboardData, setDashboardData] = useState(null);
  const [allEventsData, setAllEventsData] = useState([]);
  const [chartData, setChartData] = useState({
    data: null,
    selectedCardTitle: "",
    index: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [selectedEvent, setSelectedEvent] = useState(
    dashboardData?.topEvents[0]
  );

  // Function to handle event card click
  const handleEventClick = (event) => {
    setSelectedEvent(event);
  };

  const handleChartData = ({ data, title, index }) => {
    setChartData({ data: data, selectedCardTitle: title, index: index });
  };

  const getAllEvents = async () => {
    try {
      const { response, error } = await httpServices.get(`/event/list`);
      if (error) {
        throw error;
      }
      if (response.status === 200) {
        const events = response.data?.data || [];
        console.log("Events", response.data?.data);
        setAllEventsData(events);
      }
    } catch (error) {
      console.log("Error", error);
    }
  };

  useEffect(() => {
    const fetchDashboardData = async () => {
      setLoading(true);
      try {
        const { response, loading, error } = await httpServices.get(
          `/dashboard/vendor/details?startDate=${startDate}&endDate=${endDate}`
        );
        console.log("Responsedata from dashboard", response.data);
        if (error) {
          throw error;
        }
        setDashboardData(response.data);
        setChartData({
          data: response.data?.totalCustomer?.detailedCustomers,
          selectedCardTitle: "Total Customers",
          index: 0,
        });
      } catch (err) {
        setError("Failed to fetch data.");
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
    getAllEvents();
  }, [startDate, endDate]);

  if (loading) {
    return (
      <div className="flex h-screen justify-center items-center">
        Loading...
      </div>
    );
  }

  if (error) {
    return <div>{error}</div>;
  }

  const handleDateRangeSelection = (range) => {
    setSelectedRange(range);
    const { startDate, endDate } = calculateDateRange(range);
    setStartDate(startDate);
    setEndDate(endDate);
  };
  
  const KPI_CARDS = [
    {
      title: "Revenue Generated",
      img_url: "/images/revenue.svg",
      value: `AED ${dashboardData?.totalRevenue?.amount || "0"}`,
      data: dashboardData?.totalRevenue?.detailedRevenue,
      index: 0,
    },
    {
      title: "No of Tickets Sold",
      img_url: "/images/dashboard-card-1.svg",
      value: dashboardData?.noOfTicketSold?.total || "0",
      data: dashboardData?.noOfTicketSold?.detailedSoldTickets,
      index: 1,
    },
    {
      title: "Total Customers",
      img_url: "/images/dashboard-card-2.svg",
      value: dashboardData?.totalCustomer?.total || "0",
      data: dashboardData?.totalCustomer?.detailedCustomers,
      index: 2,
    },
  ];

  return (
    <div className=" ">
      <div className="container  ">
        <div className="main_home">
          <div className="row">
            <div className="col-lg-10 col-md-11 col-12 me-auto">
              <h4 className="text-purple text-2xl font-bold mb-1 ">
                Hello {user.name || user.username},
              </h4>
              <div className="flex justify-between flex-lg-nowrap flex-wrap gap-md-0 gap-3">
                <p className="text-[#A4AAC9] text-base">
                  Here’s your statistics. Hope you have a great day!
                </p>
                <div className="flex gap-2">
                  {["24H", "7D", "1M", "6M", "1Y"].map((item, index) => (
                    <button
                      key={item}
                      onClick={() => handleDateRangeSelection(item)}
                      className={`${
                        item === selectedRange
                          ? "purple-btn"
                          : "outline-purple-btn "
                      }`}
                    >
                      {item}
                    </button>
                  ))}

                  <DateSelect
                    allow={true}
                    setSelectedDate={setStartDate}
                    selectedDate={startDate}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* (Key Performance Indicator Cards) with fetched data */}
          <div className="row row-cols-lg-4 row-cols-md-3 row-cols-2 pt-4">
            {KPI_CARDS.map((card) => (
              <div
                key={card.index}
                className={`col  cursor-pointer ${
                  chartData.index !== card.index && "pb-3 "
                } `}
                onClick={() =>
                  handleChartData({
                    title: card.title,
                    data: card.data,
                    index: card.index,
                  })
                }
              >
                <DetailsCard
                  title={card.title}
                  img_url={card.img_url}
                  value={card.value}
                  selected={chartData.index === card.index}
                />
              </div>
            ))}
          </div>
          {/*begin::Chart*/}
          <div className="ps-4 pe-6 bg-white h-[25rem]">
            <LineChart
              title={chartData.selectedCardTitle || "Revenue Generated"}
              data={
                chartData.data || dashboardData?.totalRevenue?.detailedRevenue
              }
            />
          </div>
          {/*end::Chart*/}
          <section>
            <div className="lg:w-1/2 mt-3">
              <div className=" mb-4 ">
                <div className="bg-white p-3 rounded-lg ">
                  <div className="flex items-center justify-between pb-3">
                    <h3 className="text-darkBlue text-lg">
                      Top performed event
                    </h3>
                    <NavLink to={"/events"}>
                      <span className="text-xs text-[#628be3] font-normal">
                        All Events
                      </span>
                    </NavLink>
                  </div>

                  <div className="bg-[#F5F6FA] flex  items-center gap-3 rounded-md">
                    {dashboardData?.topEvents
                      .slice(0, 1)
                      ?.map((item, index) => (
                        <div
                          key={index}
                          onClick={() => handleEventClick(item)} // Set selected event on click
                          className={`cursor-pointer flex-col flex lg:flex-row gap-4 w-full ${
                            selectedEvent === item
                              ? " tranform scale-110 transition-all"
                              : ""
                          }`}
                        >
                          <img src="/images/home-img.svg" alt="" />
                          <div className="py-3">
                            <h3 className="text-darkBlue text-base font-medium">
                              {item.eventName ||
                                "Green Day 2025 Live in Expo City Dubai"}
                            </h3>
                            <div className="flex items-center gap-2">
                              <img src="/images/date-ico.svg" alt="" />
                              <span className="text-sm font-normal">
                                {format(item.eventDate, "dd/MM/yyyy") ||
                                  "12/10/2021"}
                              </span>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>

                  <div className="flex gap-3 flex-wrap pt-3 rounded-lg">
                    <div className="bg-[#F5F6FA] flex flex-col items-center justify-center flex-grow-1 p-3">
                      <h2 className="text-darkBlue font-semibold text-lg">
                        AED{" "}
                        {selectedEvent?.totalRevenue?.amount ||
                          dashboardData.topEvents[0]?.totalRevenue?.amount ||
                          "0"}
                      </h2>
                      <p className="text-[#959EB2] text-xs">
                        Revenue Generated
                      </p>
                    </div>
                    <div className="bg-[#F5F6FA] flex flex-col items-center justify-center flex-grow-1 p-3">
                      <h2 className="text-darkBlue font-semibold text-lg">
                        {selectedEvent?.noOfTicketSold?.total ||
                          dashboardData.topEvents[0]?.noOfTicketSold?.total ||
                          "0"}
                      </h2>
                      <p className="text-[#959EB2] text-xs">
                        No of Tickets Sold
                      </p>
                    </div>
                    <div className="bg-[#F5F6FA] flex flex-col items-center justify-center flex-grow-1 p-3">
                      <h2 className="text-darkBlue font-semibold text-lg">
                        {selectedEvent?.totalCustomer?.total ||
                          dashboardData.topEvents[0]?.totalCustomer?.total ||
                          "0"}
                      </h2>
                      <p className="text-[#959EB2] text-xs">Total Customers</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="col-lg-5 col-12 mb-4">
                <div className="flex flex-col justify-center items-center gap-3 bg-white p-3 h-full">
                  <h2 className="text-darkBlue font-semibold text-base">
                    How do you want to start your ticketing journey?
                  </h2>
                  <img src="/images/home-staging.svg" alt="" />
                  <div className="flex gap-2">
                    <button
                      className="outline-purple-btn"
                      onClick={() => {
                        navigate("/events");
                      }}
                    >
                      Host on Past venues
                    </button>
                    <button
                      className="purple-btn"
                      onClick={() => navigate("/create-venue")}
                    >
                      Start from new venue
                    </button>
                  </div>
                </div>
              </div> */}
            </div>
          </section>
        </div>
        <EventTable tableData={allEventsData || []} COLUMNS={COLUMNS} />
      </div>
    </div>
  );
}

export default Home;

const calculateDateRange = (range) => {
  const currentDate = new Date();
  let startDate = new Date(); // Initialize the start date as the current date

  switch (range) {
    case "24H":
      startDate.setDate(currentDate.getDate() - 1);
      break;
    case "7D":
      startDate.setDate(currentDate.getDate() - 7);
      break;
    case "1M":
      startDate.setMonth(currentDate.getMonth() - 1);
      break;
    case "6M":
      startDate.setMonth(currentDate.getMonth() - 6);
      break;
    case "1Y":
      startDate.setFullYear(currentDate.getFullYear() - 1);
      break;
    default:
      startDate = new Date(); // Default to current date if no range is selected
  }

  const formattedStartDate = formatDate(startDate.toISOString());
  const formattedEndDate = formatDate(currentDate.toISOString());

  return { startDate: formattedStartDate, endDate: formattedEndDate };
};
